import { CalendarDays, Clock3 } from 'lucide-react';
import { useEffect, useState } from 'react';

function getNow() {
  return new Date();
}

export function CurrentDateTime() {
  const [now, setNow] = useState(getNow);

  useEffect(() => {
    const timer = window.setInterval(() => setNow(getNow()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  const date = new Intl.DateTimeFormat('en-PH', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(now);

  const time = new Intl.DateTimeFormat('en-PH', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(now);

  return (
    <div className="hidden items-center gap-5 lg:flex">
      <div className="flex items-center gap-2 text-slate-600">
        <CalendarDays size={17} aria-hidden="true" />
        <span className="text-sm font-semibold">{date}</span>
      </div>
      <div className="flex items-center gap-2 text-slate-900">
        <Clock3 size={17} aria-hidden="true" />
        <time className="text-base font-bold tabular-nums">{time}</time>
      </div>
    </div>
  );
}
